import * as envPrm from '@/config.prm.js';
import * as envDev from '@/config.dev.js';
import * as envStaging from '@/config.staging.js';

// Seleciona o ambiente baseado na variável VUE_APP_ENV
// Se VUE_APP_ENV=development, usa config.dev.js (desenvolvimento)
// Se VUE_APP_ENV=staging, usa config.staging.js (staging)
// Se VUE_APP_ENV=production ou não definido, usa config.prm.js (produção - padrão)
let env;
if (process?.env?.VUE_APP_ENV === 'development') {
  env = envDev;
} else if (process?.env?.VUE_APP_ENV === 'staging') {
  env = envStaging;
} else {
  // Padrão: produção (prm) quando VUE_APP_ENV não está definido ou é 'production'
  env = envPrm;
}

// PRM ou Produção
export default { env };